import { Row } from "antd";

type StepsProps = {
  step: number;
};

export const Steps = ({ step }: StepsProps) => {
  return (
    <Row className="steps-container align-center">
      <Row className={`dot ${step >= 1 ? "active" : ""}`} />
      <Row className={`line ${step > 1 ? "active" : ""}`} />
      <Row className={`dot ${step > 1 ? "active" : ""}`} />
      <Row className={`line ${step > 2 ? "active" : ""}`} />
      <Row className={`dot ${step > 2 ? "active" : ""}`} />
    </Row>
  );
};
